'use client';

import dynamic from 'next/dynamic';

export const DynamicWishlistButtonWithApi = dynamic(
  () =>
    import(/* webpackChunkName: 'WishlistButtonWithApi' */ './WishlistButtonWithApi').then(
      (mod) => mod.WishlistButtonWithApi,
    ),
  {
    loading: () => null,
    ssr: false,
  },
);
